:host {
  --z-table--cells-bottom-border-size: var(
    --border-size-medium
  ); /* Needed to handle the border of the expand button cell */

  --z-table--cells-background: var(
    --color-background
  ); /* Needed to handle the background-color of the expand button cell */

  display: block;
  box-sizing: border-box;
}

:host([sticky]) {
  position: sticky;
  z-index: 2;
  top: 0;
  box-shadow: 0 2px 4px -2px var(--shadow-color-base);
}
